import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { setCupo, openCloseModalEditarCupo, doAddCupo, doUpdateCupo, openCloseModalDesactivarCupo } from "./action";
import NumberField from "../../../../Shared/fields/NumberField";

class ModalEditar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activoPrev: null,
    };
  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEditar && this.props.isOpenModalEditar) {
      const { cupo } = this.props;
      this.setState({ activoPrev: cupo.Active });
    }
  }


  handleChange = (e) => {
    const NewCupo = { ...this.props.cupo };
    if (e.element.id === "Overbook") {
      if (!e.value) { NewCupo["OverbookedMaximumAmount"] = null; }
    }
    if (e.element.id === "CupoStatus") {
      e.element.id = "Status";
    }
    if (e.element.id === "CupoOverbook") {
      e.element.id = "Overbook";
    }
    if (e.element.id === "CupoOverbookedMaximumAmount") {
      e.element.id = "OverbookedMaximumAmount";
    }
    NewCupo[e.element.id] = e.value;
    this.props.dispatch(setCupo(NewCupo));
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarCupo(true, {}, true));
  }

  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarCupo(false, {}, false));
  }

  handleSave = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      if (this.props.isNewCupo) {
        this.props.dispatch(doAddCupo(this.props.cupo));
      } else if (this.state.activoPrev && !this.props.cupo.Activo) {
        this.props.dispatch(openCloseModalDesactivarCupo(true, this.props.cupo));
      } else {
        this.props.dispatch(doUpdateCupo(this.props.cupo));
      }
    }
  }
  render() {
    const { cupo } = this.props;
    let title = "Editar Cupo";
    let saveText = "Guardar";

    if (this.props.isNewCupo) {
      title = "Agregar Cupo";
      saveText = "Agregar";
    }


    return (
      <Popup
        title={title}
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEditar && !this.props.isOpenModalDesactivar}
        width={700}
        height={this.props.isNewCupo ? 380 : 410}
        contentComponent={() => (
          <div className="dense-form">
            {this.props.isLoading && <LoadingOverlay />}
            <ValidationGroup >
              <TextField
                id="Description"
                label="Nombre del cupo"
                maxLength={60}
                value={cupo.Description}
                onChange={this.handleChange}
              />
              <SwitchField
                id="CupoStatus"
                label="Activado"
                value={!!cupo.Status}
                onChange={this.handleChange}
                switchedOffText="No"
                switchedOnText="Si"
                visible
              />

              <div className="row zero-vertical">
                <div className="col-2 zero-right">
                  <SwitchField
                    id="CupoOverbook"
                    label="Sobrecupo"
                    value={cupo.Overbook}
                    onChange={this.handleChange}
                    switchedOffText="No"
                    switchedOnText="Si"
                    visible
                  />
                </div>
                <div className="col-10">
                  <NumberField
                    inputAttr={{ maxLength: 3 }}
                    max={100}
                    min={0}
                    label="Cantidad máxima de sobrecupo"
                    id="CupoOverbookedMaximumAmount"
                    showSpinButtons
                    onChange={this.handleChange}
                    disabled={!cupo.Overbook}
                    value={cupo.OverbookedMaximumAmount}
                  />

                </div>
              </div>

              <div className="button-row">
                <div>
                  <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
                </div>
                <div>
                  <Button text={saveText} type="success" onClick={this.handleSave} useSubmitBehavior />
                </div>
              </div>
            </ValidationGroup>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEditar: state.mantenedorCupos.isOpenModalEditar,
  isOpenModalDesactivar: state.mantenedorCupos.isOpenModalDesactivar,
  cupo: state.mantenedorCupos.cupo,
  isNewCupo: state.mantenedorCupos.isNewCupo,
  isLoading: state.mantenedorCupos.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditar);
